<!--
  组件说明：部门树组件，根据传入值的类型判断返回结果，分别有：部门对象、部门ID、部门ID集合
  调用示范：
  <el-dialog title="选择部门" :visible.sync="showDialog" width="30%" center>
    <deptTree :value.sync="value" :visible.sync="showDialog"></deptTree>
  </el-dialog>
-->
<template>
  <div>
    <div style="height: 450px; overflow: auto;">
      <el-tree
        :data="data"
        :show-checkbox="Array.isArray(value)"
        default-expand-all
        node-key="bmid"
        ref="tree"
        highlight-current
        check-strictly
        :default-checked-keys="bmids"
        :props="defaultProps"
        @node-click="handleNodeClick">
      </el-tree>
    </div>
    <br>
    <div v-show="Array.isArray(value)" class="buttons" style="text-align:center;">
      <el-button type="primary" @click="getCheckedKeys">确定</el-button>
      <el-button type="primary" @click="resetChecked">清空</el-button>
    </div>
  </div>
</template>
<script>
import { getDeptList } from '@/api/user'
export default {
  data () {
    return {
      data: [],
      defaultProps: {
        children: 'children',
        label: 'bmmc'
      },
      bmids: this.value instanceof Array ? this.value : []
    }
  },
  props: {
    value: {
      type: [Object, Number, Array]
    },
    visible: Boolean
  },
  watch: {
    value (val) {
      if (val instanceof Array) {
        setTimeout(() => {
          this.bmids = val
        }, 100)
      }
    }
  },
  methods: {
    // 选择某个部门
    handleNodeClick (data) {
      // console.log(data)
      if (!this.value || this.value.constructor === Number) {
        this.$emit('update:value', data.bmid)
        this.$emit('update:visible', false)
      } else if (this.value.constructor === Object && !Array.isArray(this.value)) {
        this.$emit('update:value', data)
        this.$emit('update:visible', false)
      }
    },
    // 确定
    getCheckedKeys () {
      // console.log(this.$refs.tree.getCheckedKeys())
      if (this.value instanceof Array) {
        this.$emit('update:value', this.$refs.tree.getCheckedKeys())
        this.$emit('update:visible', false)
      }
    },
    // 重置
    resetChecked () {
      this.$emit('update:value', [])
      this.$refs.tree.setCheckedKeys([])
    },
    // 将数据转成成树形结构
    parseDeptList (deptList) {
      const bmTemp = {}
      const deptTree = {}
      // 数组转 键值对
      deptList.forEach(dept => {
        bmTemp[dept.bmid] = dept
      })
      for (const bmid in bmTemp) {
        const dept = bmTemp[bmid]
        const sjDept = bmTemp[dept.sjbm]
        if (sjDept) {
          if (!sjDept.children) {
            sjDept.children = []
          }
          sjDept.children.push(dept)
        } else {
          deptTree[bmid] = dept
        }
      }
      this.data = Object.keys(deptTree).map(key => deptTree[key])
    }
  },
  created () {
    // 获取部门列表
    getDeptList().then(res => {
      this.$http.callback(res, () => {
        // 生成部门树
        this.parseDeptList(res.data)
      })
    })
  }
}
</script>
